import Client from './Client/AxiosClient'
import { baseUrl } from './Client/AxiosClient'

const resource = `${baseUrl}/api/dashboard/clusters`

export default {

    list(){
        return Client.get(`${resource}`)
    },

    update (from, to) {
        const params = {}
        if (from && to) {
            params.from = from
            params.to = to
        }
        return Client.put(`${resource}`, null, { params })
    },

    detail(id){
        return Client.get(`${resource}/${id}`)
    }

}
